import { defineWave } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   FLORAISON — vitrine des menaces ORGANIQUES.

   Une vague de démonstration pour les archétypes biologiques : Banc (école qui
   ondule), Méduse (grappe de dards lents à traîner) et Couveur (source mobile et
   gardée qui sème des Spores). Chacun est introduit SEUL puis laissé respirer,
   dans l'ordre de sa difficulté de lecture — la même discipline que le monde 1
   impose à l'Éclat avant le Faucheur : une leçon donnée au milieu du bruit n'est
   pas une leçon.

   Le Couveur (220 PV) est placé dans un couloir central : les couloirs de bord
   (0 et 6) refusent tout ennemi de plus de 200 PV, et le registre le vérifie au
   chargement. La Spore n'apparaît jamais en propre — elle est SEMÉE par le
   Couveur en cours de combat, comme l'Œuf l'est par la Pondeuse.

   ⚠️ Le Banc entre en FILE rapprochée, jamais d'un bloc simultané : c'est
   l'échelonnement (0,15 s d'un couloir au suivant) qui décale les phases et fait
   courir la vague le long de la rangée. Lâché d'un coup, il oscillerait à
   l'unisson et ne serait qu'un rideau de corps rigide.

   ⚠️ Elle n'est volontairement câblée dans AUCUN niveau de la campagne. Le
   câblage d'un monde relève de l'équilibrage (courbe de puissance, respirations,
   silence d'avant-boss) et appartient au propriétaire du contenu de campagne, pas
   à l'ajout de ces archétypes. La vague existe pour prouver que la chaîne
   registre → levelSystem → pool → ponte tient de bout en bout ; on la dépose dans
   un niveau le jour où l'on compose le monde qui les emploie.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineWave({
  id: 'floraison',
  duration: 34,
  spawns: [
    // 1. Banc — l'école qui ondule. La leçon la plus douce : on lit une forme
    //    collective. Une vague de cinq entrée en file d'un couloir au suivant,
    //    pour que l'ondulation coure au lieu de battre à l'unisson.
    { at: 0.5, enemy: 'banc', lane: 1, count: 1, spacing: 0 },
    { at: 0.65, enemy: 'banc', lane: 2, count: 1, spacing: 0 },
    { at: 0.8, enemy: 'banc', lane: 3, count: 1, spacing: 0 },
    { at: 0.95, enemy: 'banc', lane: 4, count: 1, spacing: 0 },
    { at: 1.1, enemy: 'banc', lane: 5, count: 1, spacing: 0 },
    // Une seconde onde, plus courte, pour voir le banc « respirer » : même
    //    lecture, on accompagne le sens de la vague plutôt que de la combattre.
    { at: 4.0, enemy: 'banc', lane: 2, count: 1, spacing: 0 },
    { at: 4.15, enemy: 'banc', lane: 3, count: 1, spacing: 0 },
    { at: 4.3, enemy: 'banc', lane: 4, count: 1, spacing: 0 },

    // 2. Méduse — la grappe de traqueurs lents : tenir un déplacement pour que
    //    les dards traînent. Seule et centrale, le temps de sentir qu'un écart
    //    unique ne suffit pas.
    { at: 9.0, enemy: 'meduse', lane: 3, count: 1, spacing: 0 },

    // 3. Couveur — la source mobile et gardée : trancher tôt en perçant l'anneau,
    //    ou laisser les spores encombrer le mi-terrain. En dernier, car c'est le
    //    plus à gérer : une cible qui fuit, un anneau à passer, un nuage qui monte.
    { at: 16.0, enemy: 'couveur', lane: 3, count: 1, spacing: 0 },
  ],
});
